import { MainBookmakerMappingList as MainBookmakerMappingListComponent } from './MainBookmakerMappingList.component';
import { connector } from './MainBookmakerMappingList.connector';

export const MainBookmakerMappingList = connector(MainBookmakerMappingListComponent);
